// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Components

// Shared
import Format from 'shared/utils/format'

export class EmbeddableCartTotals extends Component {
  static displayName = 'EmbeddableCartTotals'

  static propTypes = {
    cart: PropTypes.object,
    currency: PropTypes.any,
    totalPriceAttribute: PropTypes.string,
    t: PropTypes.func
  }

  render () {
    const { cart, currency, totalPriceAttribute, t } = this.props

    if (!cart || cart.lines.length < 1) return null

    return (
      <div className="bq-totals">
        <div className="bq-detail bq-strong">
          <span>{t('user.store.subtotal')}</span>
          <span className="bq-amount">
            {Format.money(
              cart != null ? cart.get(totalPriceAttribute) : undefined,
              currency
            )}
          </span>
        </div>

        {(cart != null && cart.get('deposit_in_cents') !== 0) && (
          <div className="bq-detail">
            <span>{t('user.store.security_deposit')}</span>
            <span className="bq-amount">
              {Format.money(
                cart != null ? cart.get('deposit_in_cents') : undefined,
                currency
              )}
            </span>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, _props) => {
  let totalPriceAttribute

  if (state.settings.get('pricing.tax_strategy') === 'inclusive') {
    totalPriceAttribute = 'grand_total_with_tax_in_cents'
  } else {
    totalPriceAttribute = 'grand_total_in_cents'
  }

  return {
    currency: state.client.currency != null ? state.client.currency.toJS() : undefined,
    totalPriceAttribute
  }
}

const reduxComponent = reduxConnect(mapStateToProps, null)(EmbeddableCartTotals)

export default withTranslation('user')(reduxComponent)
